import { frfwProxy } from '../request';

export default {
  namespaced: true,
  state: {
    scanResult: {
      entname: '',
      licencesn: '',
      oper: '', //经办人
      legalName: '', //法人
      certOrder: {
        certExpiry: '',
      },
    },
    orderId: '',
    token: '',
  },
  mutations: {
    SET_SCAN_RESULT(state, scanResult) {
      Object.assign(state.scanResult, scanResult);
    },
    SET_ORDER_ID(state, orderId) {
      state.orderId = orderId;
    },
    SET_TOKEN(state, token) {
      state.token = token;
    },
  },
  actions: {
    scan(options, data = {}) {
      return frfwProxy.request({
        url: '/frfw/etl/qrid/type',
        method: 'post',
        data,
      });
    },
    async generateOrderQrcode({ dispatch, commit }, { orderId, token }) {
      commit('SET_ORDER_ID', orderId);
      commit('SET_TOKEN', token);
      return dispatch('scan', { type: '003', orderId });
    },
    async applyCert({ dispatch }) {
      return dispatch('scan', { type: '006' });
    },
    async login({ dispatch }) {
      return dispatch('scan', { type: '001' });
    },
    getScanResult(options, qrid) {
      return frfwProxy.request({
        url: '/frfw/etl/result',
        method: 'post',
        data: {
          qrid,
        },
      });
    },
  },
};
